import { useState, useEffect } from "react";

const Toggle = ({ value = true, onChange }) => {
  const [active, setActive] = useState(value);

  // Sync with parent value whenever it changes
  useEffect(() => {
    setActive(value);
  }, [value]);

  const handleToggle = (e) => {
    const checked = e.target.checked;
    setActive(checked);

    if (onChange) {
      onChange(checked);
    }
  };

  return (
    <div className="col-lg-6">
      <div className="card-body px-0">
        <div className="d-flex align-items-center flex-wrap gap-28">
          <div className="form-switch switch-primary d-flex align-items-center gap-3">
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              id="yes"
              checked={active}
              onChange={handleToggle}
            />
            <label
              className="form-check-label line-height-1 fw-medium text-secondary-light"
              htmlFor="yes"
            >
              {active ? "Active" : "In-active"}
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Toggle;
